import { Alert, AlertProps } from '../alert';
import { Logo } from './logo';
import { Hamburger, useMenuToggle } from '../menu';
import styles from './site-header.module.css';
import { PropsWithChildren } from 'react';
import { isDefined } from 'class-validator';
import { useTranslation } from 'react-i18next';
import { isTruthy } from '@lhb/utils';
import { cn } from '../../utils';

export type HeaderProps = PropsWithChildren<{
  dismiss?: (id: string) => void;
  alerts?: (Omit<AlertProps, 'children'> & {
    id: string;
    text?: React.ReactNode;
  })[];
  texts?: {
    alertCloseText: string;
    alertCloseAria: string;
  };
  menu?: React.ReactNode;
}>;

export function SiteHeader({
  alerts,
  texts,
  dismiss,
  menu,
  children,
}: HeaderProps) {
  const { t } = useTranslation();
  const { state } = useMenuToggle(true);
  return (
    <div className={styles['wrapper']}>
      {isTruthy(alerts) && (
        <div className={styles.alerts}>
          {alerts?.map(({ text, ...alert }) => (
            <Alert
              {...alert}
              key={alert.id}
              children={text}
              onClose={dismiss}
              closeAria={texts?.alertCloseAria}
              closeText={texts?.alertCloseText}
            />
          ))}
        </div>
      )}
      {menu}
      <header className={styles['site-header']}>
        <div>
          {isTruthy(menu) && (
            <div className={styles.hamburger}>
              <Hamburger
                label={t(`MENU_LABEL_${state ? 'CLOSE' : 'OPEN'}`)}
                ariaLabel={t(`MENU_ARIA_${state ? 'CLOSE' : 'OPEN'}`)}
              />
            </div>
          )}
          <div
            className={cn(
              styles['logo'],
              isTruthy(menu) && styles['hide-mobile'],
            )}
          >
            <Logo />
          </div>
          {children}
        </div>
      </header>
    </div>
  );
}
